import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { message } from 'ant-design-vue';
import { OK } from '@/common';
import { usePagination } from '@/hooks/usePagination';
import { getProductList } from '@/api/lawyerBoard';
/**
 * 当前企业账号下的产品列表：筛选、分页、勾选。
 * 查询、重置、切换账号后一律清空勾选状态。
 */
export function useProductList(accountId) {
  /** 输入框中的关键字 */
  const keyword = ref('');
  /** 实际生效的关键字，点击查询 / Enter 时才与 keyword 同步 */
  const appliedKeyword = ref('');
  const list = ref([]);
  const loading = ref(false);
  const selectedRowKeys = ref([]);
  const {
    pageTotal,
    pageIndex,
    pageSize,
    currentPageSizeChange
  } = usePagination(() => load());
  pageSize.value = 20;
  const selectedRows = computed(() => list.value.filter(item => selectedRowKeys.value.includes(item.productId)));
  const clearSelection = () => {
    selectedRowKeys.value = [];
  };
  const load = async () => {
    if (!accountId.value) {
      list.value = [];
      pageTotal.value = 0;
      return;
    }
    loading.value = true;
    try {
      const res = await getProductList({
        accountId: accountId.value,
        keyword: appliedKeyword.value,
        pageIndex: pageIndex.value,
        pageSize: pageSize.value
      });
      if (res && res.code === OK) {
        list.value = res.data.list;
        pageTotal.value = res.data.total;
      }
    } catch (error) {
      message.error('产品查询失败');
    } finally {
      loading.value = false;
    }
  };
  /** 点击查询或在输入框按 Enter */
  const search = async () => {
    appliedKeyword.value = keyword.value.trim();
    pageIndex.value = 1;
    clearSelection();
    await load();
  };
  /** 重置：清空产品名称并恢复当前账号下全部产品 */
  const reset = async () => {
    keyword.value = '';
    appliedKeyword.value = '';
    pageIndex.value = 1;
    clearSelection();
    await load();
  };
  /** 切换企业账号：清空筛选条件与勾选状态后重新加载 */
  const reloadForAccount = async () => {
    keyword.value = '';
    appliedKeyword.value = '';
    pageIndex.value = 1;
    clearSelection();
    await load();
  };
  /** 保存后刷新当前页，保持筛选条件与页码不变 */
  const refresh = () => load();
  return {
    keyword,
    appliedKeyword,
    list,
    loading,
    pageTotal,
    pageIndex,
    pageSize,
    currentPageSizeChange,
    selectedRowKeys,
    selectedRows,
    clearSelection,
    load,
    search,
    reset,
    reloadForAccount,
    refresh
  };
}